export const LOCAL_STORAGE_TENANT_ID_KEY = 'tenantId';
export const SESSION_STORAGE_TENANT_ID_KEY = 'sessionTenantId';

/** Set during logout so tenant resolution can avoid mounting the prior workspace. */
export const SESSION_STORAGE_LOGOUT_INITIATED = 'logout_initiated';

/** Deep-link target stored before auth redirect (Auth0 return path). */
export const SESSION_STORAGE_AUTH_RETURN_TO = 'auth_return_to';
